import { Box, Button, CircularProgress, Grid, InputLabel, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
  EditIconTwoTone,
  Select,
  SelectArrowDownIcon,
  SingleFieldContactInput,
  TextInput,
  Typography,
  useConfirmationModal,
} from '@room-match/shared-ui-components';
import { CustomIconButton } from 'components/Header/Header.style';
import { LocationModal } from 'components/LocationModal';
import RepresentationChip from 'components/RegistrationForm/RepresentationUnionChip/RepresentationChip';
import UnionChip from 'components/RegistrationForm/RepresentationUnionChip/UnionChip';
import { LocationActions, LocationContainer } from 'components/Settings/GeneralInformation/GeneralInformation.styles';
import Stepper from 'components/Stepper/Stepper';
import EthnicAppearances from 'data/EthnicAppearances.json';
import Gender from 'data/Gender.json';
import region from 'data/Region.json';
import unionList from 'data/Unions.json';
import { FormikProps } from 'formik';
import AdultSlider from 'pages/MyInfo/GeneralAppearance/AdultSlider';
import React, { useEffect, useMemo, useState } from 'react';
import { BsAsterisk } from 'react-icons/bs';
import { COLORS } from 'shared/constants/COLORS';
import { IUnion } from 'shared/interfaces/IAccount';
import { IAddress } from 'shared/interfaces/IAddress';
import { IGeneralSection } from 'shared/interfaces/IGeneral';
import { INewProfileMatchReponsePayload } from 'shared/interfaces/IProfile';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { IAgency } from 'shared/interfaces/utils/IAgency';
import { agencyService } from 'shared/services/agencyService';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { getCountry, getCountryCode } from 'shared/utils/countryStateMapper';
import { ls } from 'shared/utils/ls';
import { getErrorMessage } from 'shared/utils/room-shared';
import { useDebounce } from 'use-debounce';
import { CustomDialog, useStyles } from './PersonalInformation.styles';
import NumberConsent from 'shared/components/NumberConsent/NumberConsent';
const { WARNING_CONTAINER_BORDER } = COLORS;

type Props = {
  form: FormikProps<ITalentUpdatePayload>;
  setFirstName(firstName: string): void;
  setLastName(lastName: string): void;
  representatives: Array<{
    id: string;
    type: string;
    attributes: IAgency;
  }>;
  setRepresentatives(
    representatives: Array<{
      id: string;
      type: string;
      attributes: IAgency;
    }>,
  ): void;
  profileMatch?: INewProfileMatchReponsePayload;
  selectedLocation: IAddress | null;
  setSelectedLocation: React.Dispatch<React.SetStateAction<IAddress | null>>;
  generalInfo: IGeneralSection;
  setgeneralInfo: React.Dispatch<React.SetStateAction<IGeneralSection>>;
  setVal: (number: number[]) => void;
  val: number[] | null;
};

const { getCountries } = countryStateApiService();
const { getAgencies, getCompany } = agencyService();

const months = [
  {
    key: 'Jan',
    value: 1,
    disabled: false,
  },
  {
    key: 'Feb',
    value: 2,
    disabled: false,
  },
  {
    key: 'Mar',
    value: 3,
    disabled: false,
  },
  {
    key: 'Apr',
    value: 4,
    disabled: false,
  },
  {
    key: 'May',
    value: 5,
    disabled: false,
  },
  {
    key: 'Jun',
    value: 6,
    disabled: false,
  },
  {
    key: 'Jul',
    value: 7,
    disabled: false,
  },
  {
    key: 'Aug',
    value: 8,
    disabled: false,
  },
  {
    key: 'Sep',
    value: 9,
    disabled: false,
  },
  {
    key: 'Oct',
    value: 10,
    disabled: false,
  },
  {
    key: 'Nov',
    value: 11,
    disabled: false,
  },
  {
    key: 'Dec',
    value: 12,
    disabled: false,
  },
];

const PersonalInformation: React.FC<Props> = ({
  representatives,
  setRepresentatives,
  form,
  setFirstName,
  setLastName,
  profileMatch,
  selectedLocation,
  setSelectedLocation,
  generalInfo,
  setgeneralInfo,
  val,
  setVal,
}) => {
  const { handleOpen, handleSetMessage, ConfirmationModal, isOpen, handleClose } = useConfirmationModal({
    type: 'warning',
  });
  const [query, setQuery] = useState<string>('');
  const { getLS } = ls();
  const [queryValue] = useDebounce(query, 100);
  const [representativesLabel, setRepresentativesLabel] = useState<string[]>([]);
  const agency = JSON.parse(getLS('agency') || '{}');
  const [agencyRegion, setagencyRegion] = useState(form.values.country_code === 'au' ? 'Australia' : 'United States');
  const [openLocationModal, setopenLocationModal] = useState(false);
  const [openAgeRangeModal, setopenAgeRangeModal] = useState(false);
  const [calendarMonths, setCalendarMonths] = useState<typeof months>(months);
  const [calendarDays, setCalendarDays] = useState(
    Array.from({ length: 31 }, (_, i) => {
      return {
        key: (i + 1).toString(),
        value: i + 1,
      };
    }),
  );

  const calendarYears = Array.from({ length: 82 }, (_, i) => {
    const year = new Date().getFullYear() - 100;
    return {
      key: (year + i + 1).toString(),
      value: year + i + 1,
    };
  });
  const [dobYear, setDobYear] = useState(new Date().getFullYear() - 18);
  const [dobMonth, setDobMonth] = useState(new Date().getMonth() + 1);
  const [dobDay, setDobDay] = useState(new Date().getDate());

  const [slug2, setslug2] = useState('');

  const { data: companyData, isLoading: isLoadingCompany } = getCompany(agency?.slug || '');
  const { data: companyData2 } = getCompany(slug2);

  const getDaysinMonth = (month: number | string, year: number | string) => {
    return new Date(Number(year), Number(month), 0).getDate();
  };

  const setDaysArr = (days: number, maxDays?: number) =>
    Array.from({ length: days }, (_, i) => {
      return {
        key: (i + 1).toString(),
        value: i + 1,
        disabled: maxDays ? i + 1 > maxDays : false,
      };
    });

  // Make sure user is at least 18 years old
  useEffect(() => {
    const curryear = new Date().getFullYear();
    const currmonth = new Date().getMonth() + 1;
    const currday = new Date().getDate();
    const days = getDaysinMonth(dobMonth, dobYear);
    let mm = dobMonth;
    let dd = dobDay;

    if (curryear - 18 === dobYear) {
      const disabledMonths = months.map((mo, i) => (i >= currmonth ? { ...mo, disabled: true } : mo));
      setCalendarMonths(disabledMonths);
      if (dobMonth >= currmonth) {
        setDobMonth(currmonth);
        if (dobDay > currday) {
          setDobDay(currday);
          dd = currday;
        }
        mm = currmonth;
      }
      setCalendarDays(setDaysArr(days, dobMonth === currmonth ? currday : undefined));
    } else {
      setCalendarMonths(months);
      setCalendarDays(setDaysArr(days));
      if (dobDay > days || currday > days) {
        setDobDay(days);
        dd = days;
      }
    }
    const dateOfBirth = `${dobYear}-${('0' + mm).slice(-2)}-${('0' + dd).slice(-2)}`;
    form.setFieldValue('birth_date', dateOfBirth);
  }, [dobMonth, dobDay, dobYear]);

  useEffect(() => {
    if (profileMatch?.data[0]?.slug) {
      setslug2(profileMatch?.data[0]?.slug);
    } else {
      setslug2('');
    }
  }, [profileMatch?.data]);

  useEffect(() => {
    let joinedRep: any[] = [];
    if (companyData2?.data) {
      const companyDataWithIsCompany = {
        ...companyData2?.data,
        attributes: {
          ...companyData2?.data?.attributes,
          isCompany: true,
        },
      };
      // captureMessage('user has ghosted profile');
      const newRep = [...joinedRep, companyDataWithIsCompany as any];
      joinedRep = newRep;
    }

    if (companyData?.data) {
      const companyDataWithIsCompany = {
        ...companyData?.data,
        attributes: {
          ...companyData?.data?.attributes,
          isCompany: true,
        },
      };
      // captureMessage({
      //   message: 'user agency details',
      //   data: agency,
      // });
      const newRep = [...joinedRep, companyDataWithIsCompany as any];
      joinedRep = newRep;
    }

    setRepresentatives(joinedRep.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i));
  }, [companyData2?.data, companyData?.data]);

  const { data: agencies, isLoading: isAgencyLoading } = getAgencies({
    country: agencyRegion,
    search: queryValue,
  });

  const getData = useMemo(() => {
    if (isAgencyLoading) {
      return;
    } else {
      return agencies
        ? agencies.pages.filter((v, index) => index === 0).map((i) => i.data.agencies_connection.nodes)[0]
        : undefined;
    }
  }, [agencies, isAgencyLoading]);

  const classes = useStyles();

  const handleRemoveRepresentative = (v: string) => {
    const filteredRepresentatives = representatives.filter((k) => k.id != v);
    setRepresentatives(filteredRepresentatives);
    const filteredRepresentativesLabel = representativesLabel.filter((k) => k != v);
    setRepresentativesLabel(filteredRepresentativesLabel);
  };
  const { data: countriesData } = getCountries();
  const countries = region.map((region) => ({ key: region.value, value: region.value }));

  useEffect(() => {
    setLastName(form.values.stage_last_name || '');
    setFirstName(form.values.stage_first_name || '');
  }, [form.values.stage_first_name, form.values.stage_last_name]);

  const onSelectRepresentative = (
    representatives: Array<{
      id: string;
      type: string;
      attributes: IAgency;
    }>,
  ) => {
    setRepresentatives(representatives);

    if (representatives[0].attributes?.addresses?.length) {
      const primaryWorkingLocation = representatives[0].attributes?.addresses?.filter(
        (address) => address.primary && address.type === 'work',
      )[0];

      if (primaryWorkingLocation && !selectedLocation) {
        setSelectedLocation({ id: '', type: '', attributes: { ...primaryWorkingLocation } });
      }
    }
  };

  const handleAutocompleteChange = (field_key: string, val: string | null) => {
    setgeneralInfo((i) => ({ ...i, [field_key]: val }));
  };

  const removeUnion = (id: string) => {
    if (Boolean(form.values.unions) && form.values.unions?.length === 1) {
      form.setFieldValue(
        'unions',
        form.values.unions.filter((v) => v.id_number !== id),
      );
    }
  };

  useEffect(() => {
    //check if form vountry code is touched
    if (form.touched.country_code) return;
    const code = (profileMatch?.data || []).length
      ? getCountryCode(countriesData, profileMatch?.data[0].agency_country || 'au').toLowerCase()
      : agency.country
        ? getCountryCode(countriesData, agency.country).toLowerCase()
        : form.values.country_code || 'au';

    if (code !== form.values.country_code) {
      form.setFieldValue('country_code', code);
    }
  }, [profileMatch, agency, countriesData, form]);

  console.log({ form });

  return (
    <Box component="div" className={classes.root}>
      <Grid data-cy="body" item className={classes.header}>
        <Typography fontSize={24} style={{ marginBottom: 10 }}>
          Contact Information
        </Typography>
        <Stepper steps={3} active={1} />
      </Grid>
      <Grid item className={classes.form}>
        <Grid item style={{ marginBottom: 5 }}>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Legal Name
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <TextInput
            data-cy="legal-first-name"
            autoComplete="off"
            placeholder="First name…"
            name="first_name"
            value={form.values.first_name}
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('first_name', e.target.value.trim());
            }}
            onChange={(e) => {
              if (!form.touched.stage_first_name) form.setFieldValue('stage_first_name', e.target.value.trim());
              // setFirstName(e.target.value);
              if (form.errors.first_name && !form.touched.first_name) {
                form.setFieldTouched('first_name');
                form.validateField('first_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.first_name, form.errors.first_name)}
          />
          <TextInput
            data-cy="legal-middle-name"
            autoComplete="off"
            className={classes.noLabelFix}
            placeholder="Middle name…"
            name="middle_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('middle_name', e.target.value.trim());
            }}
            value={form.values.middle_name}
            onChange={(e) => {
              if (!form.touched.stage_middle_name) form.setFieldValue('stage_middle_name', e.target.value.trim());
              form.handleChange(e);
            }}
          />
          <TextInput
            data-cy="legal-last-name"
            autoComplete="off"
            className={classes.noLabelFix}
            placeholder="Last name…"
            name="last_name"
            value={form.values.last_name}
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('last_name', e.target.value.trim());
            }}
            onChange={(e) => {
              if (!form.touched.stage_last_name) form.setFieldValue('stage_last_name', e.target.value.trim());
              // setLastName(e.target.value);
              if (form.errors.last_name && !form.touched.last_name) {
                form.setFieldTouched('last_name');
                form.validateField('last_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.last_name, form.errors.last_name)}
          />
        </Grid>
        <Grid item style={{ marginBottom: 5 }}>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Stage Name
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <TextInput
            data-cy="stage-first-name"
            placeholder="Enter stage first name…"
            name="stage_first_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_first_name', e.target.value.trim());
            }}
            value={form.values.stage_first_name}
            onChange={(e) => {
              if (form.errors.stage_first_name && !form.touched.stage_first_name) {
                form.setFieldTouched('stage_first_name');
                form.validateField('stage_first_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_first_name, form.errors.stage_first_name)}
          />

          <TextInput
            data-cy="stage-middle-name"
            className={classes.noLabelFix}
            placeholder="Enter stage middle name…"
            name="stage_middle_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_middle_name', e.target.value.trim());
            }}
            value={form.values.stage_middle_name}
            onChange={(e) => {
              if (form.errors.stage_middle_name && !form.touched.stage_middle_name) {
                form.setFieldTouched('stage_middle_name');
                form.validateField('stage_middle_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_middle_name, form.errors.stage_middle_name)}
          />

          <TextInput
            data-cy="stage-last-name"
            className={classes.noLabelFix}
            placeholder="Enter stage last name…"
            name="stage_last_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_last_name', e.target.value.trim());
            }}
            value={form.values.stage_last_name}
            onChange={(e) => {
              if (form.errors.stage_last_name && !form.touched.stage_last_name) {
                form.setFieldTouched('stage_last_name');
                form.validateField('stage_last_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_last_name, form.errors.stage_last_name)}
          />
        </Grid>

        <div>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Gender
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <Select
            data-cy="gender-dropdown"
            variant="outlined"
            fullWidth
            data={Gender}
            value={form.values.gender}
            IconComponent={SelectArrowDownIcon}
            name="gender"
            onBlur={() => form.setFieldTouched('gender')}
            onChange={(e) => {
              if (form.errors.gender && !form.touched.gender) {
                form.setFieldTouched('gender');
                form.validateField('gender');
              }
              form.handleChange(e);
            }}
            placeHolder="Select Gender"
            errorMessage={getErrorMessage(form.touched.gender && !form.values.gender, 'Gender is required')}
          />
        </div>

        <Grid item>
          <InputLabel style={{ justifyContent: 'unset', marginBottom: 10 }}>
            Date of Birth
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Select
                data-cy="month-dropdown"
                variant="outlined"
                fullWidth
                data={calendarMonths}
                value={dobMonth}
                IconComponent={SelectArrowDownIcon}
                name="dobMonth"
                onChange={(e) => {
                  setDobMonth(Number(e.target.value));
                }}
                placeHolder="Month"
                renderMenu={(item) => (
                  <MenuItem value={item.value} key={item.key} disabled={item.disabled}>
                    {item.key}
                  </MenuItem>
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Select
                data-cy="day-dropdown"
                variant="outlined"
                fullWidth
                data={calendarDays}
                value={dobDay}
                IconComponent={SelectArrowDownIcon}
                name="dobDay"
                onChange={(e) => {
                  setDobDay(Number(e.target.value));
                }}
                placeHolder="Day"
                renderMenu={(item) => (
                  <MenuItem value={item.value} key={item.key} disabled={item.disabled}>
                    {item.key}
                  </MenuItem>
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Select
                data-cy="year-dropdown"
                variant="outlined"
                fullWidth
                data={calendarYears}
                value={dobYear}
                IconComponent={SelectArrowDownIcon}
                name="dobYear"
                onChange={(e) => {
                  setDobYear(Number(e.target.value));
                }}
                placeHolder="Year"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <InputLabel style={{ justifyContent: 'unset', margin: '10px 0 10px 0' }}>
            Age Range
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <LocationContainer
            $isEmpty={true}
            style={{ border: `solid 1px ${COLORS.DARK_BORDER}`, cursor: 'pointer', marginBottom: 10 }}
            onClick={() => setopenAgeRangeModal(true)}
          >
            {val ? (
              <Typography fontSize={14}>
                {val[0]} to {val[1]}
              </Typography>
            ) : (
              <Typography fontSize={14}>No Age Range Added</Typography>
            )}
            <LocationActions></LocationActions>
          </LocationContainer>
        </Grid>

        <Grid item>
          <InputLabel style={{ justifyContent: 'unset', marginTop: 10 }}>
            Primary Ethnic Appearance
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          {/* <Select
                variant="outlined"
                fullWidth
                data={EthnicAppearances}
                IconComponent={SelectArrowDownIcon}
                placeHolder={'Select'}
                onChange={handleChange}
                name="ethnic_appearance_primary"
                value={generalInfo.ethnic_appearance_primary}
              /> */}
          <Autocomplete
            data-cy="ethnic-dropdown"
            onChange={(e, newValue) => {
              handleAutocompleteChange('ethnic_appearance_primary', newValue);
            }}
            value={generalInfo.ethnic_appearance_primary}
            options={EthnicAppearances.map((i) => i.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            renderInput={(params) => <TextInput placeholder={'Select'} {...params} />}
            disableClearable
          />
        </Grid>

        <Grid item>
          <InputLabel style={{ justifyContent: 'unset', marginBottom: -10 }}>
            Cell Number
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <SingleFieldContactInput
            // data-cy="cell-number"
            style={{ width: '100%' }}
            country={form.values.country_code}
            name={`other_phone_numbers[${0}].number`}
            inputValue={(form.values.other_phone_numbers || [])[0]?.number}
            onChange={(value, data) => {
              const country = getCountry(countriesData, data.countryCode.toUpperCase()) || data.name;
              form.setTouched({ ...form.touched, country_code: true });
              form.setValues({
                ...form.values,
                contact_no: value,
                country_code: data.countryCode,
                country: country,
              });
              form.setFieldValue('other_phone_numbers[0].number', value);
              form.setFieldValue(`other_phone_numbers[0].country_code`, data.countryCode);
              const regions = countries.map((c) => c.value);
              if (regions.includes(country)) {
                setagencyRegion(country);
              }
            }}
          />
          <NumberConsent
            aggreed={form.values.preferences?.notification?.sms || false}
            setAgreed={(value) => form.setFieldValue('preferences.notification.sms', value)}
          />
        </Grid>
        {/* <Grid item for union>*/}
        {form.values.country_code === 'us' ? (
          <Grid item>
            <InputLabel style={{ justifyContent: 'unset', marginTop: 10 }}>
              Union
              <BsAsterisk className="required-asterisk" />
            </InputLabel>
            {form.values.unions?.length ? (
              form.values.unions.map((union: IUnion, index: number) => (
                <UnionChip
                  key={index}
                  unionId={union.id_number}
                  removeUnion={() => removeUnion(union.id_number)}
                  setUnionId={(id: string) => {
                    form.setFieldValue('unions', [
                      {
                        id_number: id,
                        name: union.name,
                      },
                    ]);
                  }}
                  unionName={union.name}
                />
              ))
            ) : (
              <Select
                data-cy="union-dropdown"
                variant="outlined"
                fullWidth
                data={unionList}
                IconComponent={SelectArrowDownIcon}
                placeHolder={'Select'}
                onChange={(e) => {
                  form.setFieldValue('unions', [
                    {
                      id_number: '',
                      name: e.target.value,
                    },
                  ]);
                }}
                name="unions"
                value={form.values.unions}
              />
            )}
          </Grid>
        ) : (
          <React.Fragment />
        )}

        {profileMatch?.data.length || agency.name || (!agency.id && agency.profileId) ? (
          <InputLabel style={{ marginTop: 15 }} id="representationStatus">
            Representation
          </InputLabel>
        ) : (
          <>
            <Grid item>
              <InputLabel style={{ marginTop: 15 }} id="representationStatus">
                Representation Status
              </InputLabel>
              <Select
                data-cy="representation-dropdown"
                variant="outlined"
                fullWidth
                data={[
                  {
                    key: form.values.country_code === 'au' ? 'Freelance' : 'Non-Represented',
                    value: 'Non-Represented',
                  },
                  { key: 'Agency Representation', value: 'agency_representation' },
                ]}
                value={form.values.representation}
                onChange={(e: any) => {
                  // captureMessage({
                  //   message: 'user has selected representation',
                  //   data: e.target.value,
                  // });
                  form.setFieldValue('representation', e.target.value);
                  if (e.target.value === 'Non-Represented') setRepresentatives([]);
                }}
                IconComponent={SelectArrowDownIcon}
                name="representation"
              />
            </Grid>

            {form.values.representation === 'Non-Represented' ? (
              ''
            ) : (
              <Grid item>
                <div>
                  <InputLabel id="representationStatus">Region</InputLabel>
                  <Select
                    data-cy="region-dropdown"
                    variant="outlined"
                    fullWidth
                    data={countries}
                    value={agencyRegion}
                    onChange={(e: any) => {
                      setagencyRegion(e.target.value);
                    }}
                    IconComponent={SelectArrowDownIcon}
                    name="country"
                  />
                </div>
                <InputLabel style={{ justifyContent: 'unset', marginTop: 15 }}>
                  Add Representatives
                  <BsAsterisk className="required-asterisk" />
                </InputLabel>
                <Autocomplete
                  data-cy="add-representative-dropdown"
                  id="multiple-tags"
                  multiple
                  value={representatives as any}
                  className={classes.autocompleteFix}
                  options={getData?.map((a) => ({ attributes: { ...a }, id: a.id })) || []}
                  getOptionLabel={(option: any) => {
                    const { full_name, name } = option.attributes;
                    //create a logic that will check current inputValue if it contains agency name then retunr the agency name else return the full name
                    if (queryValue.length > 0) {
                      if (full_name && full_name.toLowerCase().includes(queryValue.toLowerCase())) {
                        return full_name.toLowerCase();
                      } else {
                        return name;
                      }
                    }

                    return '';
                  }}
                  getOptionSelected={(option, value) => {
                    return option.id === value.id;
                  }}
                  fullWidth
                  renderTags={() => null}
                  onChange={(e, newValue: any[]) => {
                    // captureMessage({
                    //   message: 'user has selected representation',
                    //   data: newValue,
                    // });
                    if (newValue) {
                      setRepresentatives(newValue.filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i));
                    }
                  }}
                  renderOption={(option: any) => {
                    const { name, company_logo, full_name, type } = option.attributes;

                    return (
                      <Grid
                        container
                        spacing={2}
                        style={{
                          margin: 5,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '.5em',
                          flexWrap: 'nowrap',
                        }}
                      >
                        <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img
                            style={{ borderRadius: 10 }}
                            loading="lazy"
                            width="37"
                            src={
                              company_logo ||
                              `https://ui-avatars.com/api/?background=random&name=${full_name || name}&length=1`
                            }
                            alt=""
                          />
                        </Grid>
                        <Grid item xs={11}>
                          <Grid item xs={12} style={{ fontSize: 16, fontWeight: 500 }}>
                            {full_name || name}
                          </Grid>
                          <Grid item xs={12} style={{ color: COLORS.LIGHT_USERNAME, fontSize: 14 }}>
                            <div style={{ display: 'flex' }}>
                              <Typography
                                fontSize={12}
                                fontWeight={700}
                                style={{ fontStyle: 'italic' }}
                                color="lightGrey"
                              >
                                {name ? `${name} -\xa0` : ''}
                              </Typography>
                              <Typography fontSize={12} style={{ fontStyle: 'italic' }} color="lightGrey">
                                {type ? type : ' '}
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={'Type / Search Agency…'}
                      variant="outlined"
                      margin="normal"
                      onChange={(e) => {
                        setQuery(e.target.value);
                        form.handleChange(e);
                      }}
                    />
                  )}
                />

                {/* <TextInput label={'Add Representatives'} placeholder="Type / Search Agency…" /> */}
              </Grid>
            )}
          </>
        )}

        {/* if casting private */}
        {agency.profileId && !agency.id ? (
          <LocationContainer
            $isEmpty={true}
            style={{
              border: `solid 1px ${WARNING_CONTAINER_BORDER}`,
              cursor: 'pointer',
              background: 'rgb(220, 98, 38, 10%)',
              marginTop: 0,
              pointerEvents: 'none',
            }}
          >
            <Typography fontSize={14}>Casting Private Talent</Typography>
            <LocationActions></LocationActions>
          </LocationContainer>
        ) : (
          <React.Fragment />
        )}

        <Grid item style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: 15 }}>
          {!isLoadingCompany ? (
            representatives.map((i) => (
              <RepresentationChip
                key={i.id}
                bypassCode={i.attributes.isCompany}
                agency={i}
                handleRemoveRepresentative={handleRemoveRepresentative}
                setRepresentatives={onSelectRepresentative}
                representatives={representatives}
              />
            ))
          ) : (
            <CircularProgress size={30} />
          )}

          {/* {(profileMatch?.data.length || agency.slug) && companyData?.data ? (
            !isLoadingCompany ? (
              <RepresentationChip
                bypassCode
                agency={companyData?.data as any}
                handleRemoveRepresentative={handleRemoveRepresentative}
                setRepresentatives={setRepresentatives}
                representatives={representatives}
              />
            ) : (
              <CircularProgress size={30} />
            )
          ) : (
            <React.Fragment />
          )} */}
        </Grid>
        <div style={{ gap: 5, display: 'flex', flexDirection: 'column' }}>
          <InputLabel id="primaryLocation" style={{ marginTop: representatives.length ? 0 : -20 }}>
            Working Location
          </InputLabel>
          {selectedLocation ? (
            <LocationContainer style={{ padding: '0 0 0 15px' }}>
              <Typography fontSize={14} style={{ maxWidth: 245 }}>
                {selectedLocation.attributes?.city_suburb} /{' '}
                {getCountry(countriesData, selectedLocation.attributes?.country_code) ||
                  selectedLocation.attributes?.country_code}
                {selectedLocation.attributes?.zip_code ? ` / ${selectedLocation.attributes?.zip_code}` : ''}
              </Typography>
              <LocationActions>
                <CustomIconButton style={{ height: 48, marginLeft: 10 }}>
                  <EditIconTwoTone
                    onClick={() => {
                      setopenLocationModal(true);
                    }}
                  />
                </CustomIconButton>
              </LocationActions>
            </LocationContainer>
          ) : (
            <LocationContainer
              data-cy="working-location"
              $isEmpty={representatives.length === 0}
              onClick={() => setopenLocationModal(true)}
            >
              <Typography fontSize={14}>No Location Added</Typography>
              <LocationActions></LocationActions>
            </LocationContainer>
          )}
        </div>
      </Grid>
      {/* {<LocationModal
        open={openLocationModal}
        onClose={setopenLocationModal}
        data={selectedLocation}
        ifNoAddresses={
          accountDetails &&
          accountDetails?.data.attributes.addresses.data.filter(
            (v) => v.attributes.primary === true && v.attributes.type === 'work',
          ).length > 0
        }
        type="general"
      />} */}
      {openLocationModal ? (
        <LocationModal
          open={openLocationModal}
          onClose={setopenLocationModal}
          data={selectedLocation}
          ifNoAddresses={Boolean(selectedLocation)}
          type="work"
          setSelectedLocation={setSelectedLocation}
          country={form.values.country}
        />
      ) : (
        <React.Fragment />
      )}
      {openAgeRangeModal ? (
        <CustomDialog
          open={openAgeRangeModal}
          onClose={() => setopenAgeRangeModal(false)}
          maxWidth="sm"
          fullWidth
          aria-labelledby="simple-dialog-title"
        >
          <div style={{ padding: '40px 40px 20px 40px' }}>
            <AdultSlider slim val={val} setVal={setVal} />
            <Button
              fullWidth
              onClick={() => setopenAgeRangeModal(false)}
              style={{ background: COLORS.PRIMARY, marginTop: 40 }}
            >
              Done
            </Button>
          </div>
        </CustomDialog>
      ) : (
        <React.Fragment />
      )}
    </Box>
  );
};

export default PersonalInformation;
